import(/* webpackMode: "eager", webpackExports: ["SidebarContainer"] */ "/vercel/path0/apps/web/src/app/(networks)/(evm)/_common/ui/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EdgeProvider"] */ "/vercel/path0/apps/web/src/providers/edge-config-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DerivedstateCrossChainSwapProvider"] */ "/vercel/path0/apps/web/src/ui/swap/cross-chain/derivedstate-cross-chain-swap-provider.tsx");
